var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      disabledSave: _vm.disabled,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "50%",
      textButtonSave: "Salvar Cenário",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            autofocus: "",
                            dense: "",
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.localModel.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "name", $$v)
                            },
                            expression: "localModel.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("sys-select-shift", {
                          attrs: {
                            model: _vm.localModel.shifts,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.shifts,
                            label: "Turno*",
                            dense: "",
                            multiple: "",
                            "select-all": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.localModel, "shifts", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-campus", {
                          attrs: {
                            model: _vm.localModel.campuses,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.campuses,
                            label: "Campus*",
                            multiple: "",
                            dense: "",
                            "select-all": "",
                            "only-active": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.localModel,
                                "campuses",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-course", {
                          attrs: {
                            model: _vm.localModel.courses,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.courses,
                            label: "Curso",
                            multiple: "",
                            dense: "",
                            "select-all": "",
                            "only-active": "",
                            shifts: _vm.localModel.shifts,
                            "campus-id": _vm.localModel.campuses
                              ? _vm.localModel.campuses
                                  .map((c) => c.id)
                                  .join(",")
                              : null,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.localModel, "courses", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Considerar junção entre campus diferentes",
                            inset: "",
                            label: "Junção entre campus",
                          },
                          model: {
                            value: _vm.localModel.join_between_campuses,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localModel,
                                "join_between_campuses",
                                $$v
                              )
                            },
                            expression: "localModel.join_between_campuses",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Considerar apenas as ofertas com tipo de carga horária digital",
                            inset: "",
                            label: "Somente disciplina digital",
                          },
                          model: {
                            value: _vm.localModel.join_only_digital,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "join_only_digital", $$v)
                            },
                            expression: "localModel.join_only_digital",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Considerar apenas as ofertas que não possuem junção cadastrada",
                            inset: "",
                            label: "Grades sem Junção",
                            disabled: false,
                          },
                          model: {
                            value: _vm.localModel.only_grid_not_join,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localModel,
                                "only_grid_not_join",
                                $$v
                              )
                            },
                            expression: "localModel.only_grid_not_join",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Considerar previsão de alunos ao invés do número de alunos confirmados",
                            inset: "",
                            label: "Previsão de Alunos",
                          },
                          model: {
                            value: _vm.localModel.consider_students_forecast,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localModel,
                                "consider_students_forecast",
                                $$v
                              )
                            },
                            expression: "localModel.consider_students_forecast",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper":
                              "Realizar junção entre cursos do mesmo cluster",
                            inset: "",
                            label: "Cluster de Cursos",
                          },
                          model: {
                            value: _vm.localModel.consider_course_cluster,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localModel,
                                "consider_course_cluster",
                                $$v
                              )
                            },
                            expression: "localModel.consider_course_cluster",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            "text-helper": "Equalizar número de alunos",
                            inset: "",
                            label: "Equalizar alunos",
                            disabled: "",
                          },
                          model: {
                            value: _vm.localModel.equalize_students,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "equalize_students", $$v)
                            },
                            expression: "localModel.equalize_students",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.joinTypes,
                            label: "Tipo de Junção",
                            "item-value": "id",
                            "item-text": "name",
                          },
                          model: {
                            value: _vm.localModel.join_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "join_type", $$v)
                            },
                            expression: "localModel.join_type",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-dynamic-division-type", {
                          attrs: {
                            model: _vm.localModel.dynamic_division_type_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.dynamic_division_type_id,
                            label: "Origem Limite de Alunos",
                            dense: "",
                            "show-description": "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.localModel,
                                "dynamic_division_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.calculationTypes,
                            label: "Cálculo da Capacidade",
                            "item-value": "id",
                            "item-text": "name",
                            dense: "",
                          },
                          model: {
                            value: _vm.localModel.calculation_type_capacity,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localModel,
                                "calculation_type_capacity",
                                $$v
                              )
                            },
                            expression: "localModel.calculation_type_capacity",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.limit_classroom,
                            label: "Limite Teórica*",
                          },
                          model: {
                            value: _vm.localModel.limit_classroom,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "limit_classroom", $$v)
                            },
                            expression: "localModel.limit_classroom",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.limit_practice,
                            label: "Limite Prática*",
                          },
                          model: {
                            value: _vm.localModel.limit_practice,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "limit_practice", $$v)
                            },
                            expression: "localModel.limit_practice",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.limit_digital,
                            label: "Limite Digital*",
                          },
                          model: {
                            value: _vm.localModel.limit_digital,
                            callback: function ($$v) {
                              _vm.$set(_vm.localModel, "limit_digital", $$v)
                            },
                            expression: "localModel.limit_digital",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }